import $ from 'jquery';
import initStickyKit from './sticky-kit.js';

$.fn.stick_in_parent = initStickyKit;

export default $;
